import type { BookingData } from '../types';

const API_BASE = import.meta.env.VITE_API_BASE as string;

export async function fetchGeo(): Promise<{ country: string }> {
  try {
    const res = await fetch(`${API_BASE}/geo`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return (await res.json()) as { country: string };
  } catch {
    const lang = navigator.language || 'es-NI';
    const country = lang.split('-')[1]?.toUpperCase() || 'NI';
    return { country };
  }
}

export async function fetchBooking(id: string): Promise<BookingData> {
  const res = await fetch(`${API_BASE}/booking/${encodeURIComponent(id)}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as BookingData;
}

export async function fetchBookingByContact(contactId: string): Promise<BookingData> {
  const res = await fetch(`${API_BASE}/booking/by-contact/${encodeURIComponent(contactId)}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as BookingData;
}
